<app-header></app-header>
<div class="auth-container flex flex-col lg:flex-row" style="margin-top: -30px;">
        <!-- Left Side (Branding) - Hidden on mobile -->
        <div class="hidden lg:flex lg:w-1/2 bg-gradient-to-br from-wattpad-primary to-wattpad-secondary items-center justify-center p-12">
            <div class="max-w-md text-center text-white">
                <h1 class="text-4xl font-bold mb-6">Welcome Back!</h1>
                <p class="text-lg mb-8">Step back into the world of imagination — whether you're here to read thrilling stories or create your own.</p>
<p class="mb-3">Millions of stories are waiting... and yours might be the next.</p>
                <div class="flex justify-center space-x-4">
                    <div class="bg-white/20 p-3 rounded-full">
                        <i class="fas fa-book-open text-xl"></i>
                    </div>
                    <div class="bg-white/20 p-3 rounded-full">
                        <i class="fas fa-heart text-xl"></i>
                    </div>
                    <div class="bg-white/20 p-3 rounded-full">
                        <i class="fas fa-users text-xl"></i>
                    </div>
                </div>
            </div>
        </div>

        <!-- Right Side (Form) -->
        <div class="w-full lg:w-1/2 flex items-center justify-center p-6 lg:p-12">
            <div class="w-full max-w-md">
                

                <div class="bg-white dark:bg-gray-800 rounded-xl shadow-sm p-6 lg:p-8">
                    <h2 class="text-2xl font-bold mb-6" *ngIf="!success">Reset Password</h2>
                    <div *ngIf="loading" class="loading-message">
  <p>Verifying reset link...</p>
</div>

<div *ngIf="!loading && !valid && !success" class="error-message">
  <h2>Password Reset Failed</h2>
  
  <a  routerLink="/forgot-password"
    class="w-full bg-wattpad-primary text-white py-3 px-4 rounded-lg font-medium hover:bg-[#E5274B]">
    Request new reset link
</a>
</div>

<!-- Success Message -->
<div *ngIf="success" class="success-message text-center">
  <h2>{{ message }}</h2>
  <button (click)="loginredirect()"
    class="bg-wattpad-primary text-white py-3 px-6 rounded-lg mt-4 hover:bg-[#E5274B]">
    Click here to Login
  </button>
</div>
                    <form *ngIf="!success && valid && !loading" (ngSubmit)="onSubmit()">
  <div *ngIf="error" class="text-red-500 mb-4">{{ error }}</div>

  <div class="mb-4">
    <label for="password" class="block text-sm font-medium mb-2">New Password</label>
    <input type="password" id="password"
     class="w-full px-4 py-3 rounded-lg border border-gray-300 dark:border-gray-700 focus:outline-none focus:ring-2 focus:ring-wattpad-primary focus:border-transparent dark:bg-gray-700"
      [(ngModel)]="password" name="password" required>
  </div>

  <div class="mb-4">
    <label for="confirmPassword" class="block text-sm font-medium mb-2">Confirm Password</label>
    <input type="password" id="confirmPassword"
      class="w-full px-4 py-3 rounded-lg border border-gray-300 dark:border-gray-700 focus:outline-none focus:ring-2 focus:ring-wattpad-primary focus:border-transparent dark:bg-gray-700"
      [(ngModel)]="confirmPassword" name="confirmPassword" required>
  </div>

  <button type="submit"
    class="w-full bg-wattpad-primary text-white py-3 px-4 rounded-lg font-medium hover:bg-[#E5274B]">
    Reset Password
  </button>
</form>

                    
                </div>
            </div>
        </div>
    </div>

    <!-- Mobile Bottom Navigation -->
    <nav class="bottom-nav fixed bottom-0 left-0 right-0 bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 lg:hidden">
        <div class="flex justify-around items-center h-full">
            <a href="index4.html" class="text-gray-500 dark:text-gray-400 flex flex-col items-center">
                <i class="fas fa-home text-xl"></i>
                <span class="text-xs mt-1">Home</span>
            </a>
            <a href="#" class="text-gray-500 dark:text-gray-400 flex flex-col items-center">
                <i class="fas fa-search text-xl"></i>
                <span class="text-xs mt-1">Search</span>
            </a>
            <a href="#" class="text-gray-500 dark:text-gray-400 flex flex-col items-center">
                <i class="fas fa-bookmark text-xl"></i>
                <span class="text-xs mt-1">Library</span>
            </a>
            <a href="#" class="text-wattpad-primary flex flex-col items-center">
                <i class="fas fa-user text-xl"></i>
                <span class="text-xs mt-1">Profile</span>
            </a>
        </div>
    </nav>